import React from 'react'
import { Field } from 'formik'
import { yup } from 'civic-champs-shared/api/utils'
import { StyledOutlinedTextField } from 'civic-champs-shared/formik/components'
import { StyledAutocomplete } from 'components/StyledAutocomplete'
import { timezones } from 'civic-champs-shared/helpers/timezones'
import { ModalButtonsProps, OrganizationLayoutModal } from './OrganizationLayoutModal'
import { OrganizationFormData } from 'organization/types'

const validationSchema = yup.object({
  name: yup.string().min(1).required(),
  website: yup
    .string()
    .trim()
    .matches(/^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([/?].*)?$/)
    .required(),
  timeZone: yup
    .object()
    .test('is-valid-timezone', 'Timezone is a required field', timeZone => {
      const value = timeZone?.value
      if (!value) return false
      try {
        Intl.DateTimeFormat(undefined, { timeZone: value })
        return true
      } catch {
        return false
      }
    })
    .required('Timezone is a required field'),
})

export default function OrganizationDetailsScreen(props: {
  formData: OrganizationFormData
  buttonsProps: ModalButtonsProps
}) {
  const { formData, buttonsProps } = props

  return (
    <OrganizationLayoutModal buttonsProps={buttonsProps} formData={formData} validationSchema={validationSchema}>
      <Field
        component={StyledOutlinedTextField}
        id="name"
        name="name"
        label="Organization Name*"
        variant="outlined"
        fullWidth
      />
      <Field
        name="timeZone"
        placeholder="Time Zone"
        label="Time Zone*"
        component={StyledAutocomplete}
        options={timezones}
        getOptionLabel={({ name }: { name: string; value: string }) => name}
        notched={true}
      />
      <Field
        component={StyledOutlinedTextField}
        id="website"
        name="website"
        label="Website*"
        variant="outlined"
        fullWidth
      />
    </OrganizationLayoutModal>
  )
}
